import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "flex items-center"
};
import { CupCompetition } from "@/modules/competitions/entity";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import Flag from "@/modules/vue/components/Flag.vue";
import MatchdayComponent from "@/modules/competitions/components/Matchday.vue";
import { onBeforeRouteLeave } from "vue-router";
import ItemsPaginator from "@/modules/vue/components/ItemsPaginator.vue";
import Submenu from "./Submenu";
export default /*#__PURE__*/_defineComponent({
  __name: 'Cup',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const competition = ref();
    const startPage = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      competition.value = await CupCompetition.createQueryBuilder('competition').innerJoinAndSelect('competition.divisions', 'division').innerJoinAndSelect('competition.country', 'country').leftJoinAndSelect('competition.winner', 'winnerTeam').innerJoinAndSelect('division.matchdays', 'matchday').innerJoinAndSelect('matchday.division', 'division2').innerJoinAndSelect('matchday.season', 'season').leftJoinAndSelect('matchday.matches', 'match').leftJoinAndSelect('match.homeTeam', 'homeTeam').leftJoinAndSelect('match.awayTeam', 'awayTeam').where('season.current = true').andWhere('competition.id = :competitionId', {
        competitionId: route.params.id
      }).getOneOrFail();
      const hasUnfinishedDivisions = competition.value.divisions.filter(d => !d.finished).length > 0;
      startPage.value = route.query.divisionId ? competition.value.divisions.findIndex(d => d.id == route.query.divisionId) + 1 : hasUnfinishedDivisions ? competition.value.divisions.findIndex(d => !d.finished) + 1 : competition.value.divisions.length;
    })), __temp = await __temp, __restore(), __temp);
    onBeforeRouteLeave(watch(() => route.params, refresh));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [competition.value.country ? (_openBlock(), _createBlock(Flag, {
          key: 0,
          country: competition.value.country,
          class: "mr-2"
        }, null, 8, ["country"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(competition.value.name), 1)])]),
        submenu: _withCtx(() => [_createVNode(_unref(Submenu))]),
        default: _withCtx(() => [_createVNode(ItemsPaginator, {
          "all-items": competition.value.divisions,
          "per-page": 1,
          "start-page": startPage.value
        }, {
          default: _withCtx(({
            items
          }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, division => {
            return _openBlock(), _createElementBlock("div", {
              key: division.id,
              class: "mb-2"
            }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(division.matchdays, matchday => {
              return _openBlock(), _createBlock(MatchdayComponent, {
                key: matchday.id,
                matchday: matchday,
                "competition-winner": competition.value.winner
              }, null, 8, ["matchday", "competition-winner"]);
            }), 128))]);
          }), 128))]),
          display: _withCtx(({
            items
          }) => [_createTextVNode(_toDisplayString(items[0].name), 1)]),
          _: 1
        }, 8, ["all-items", "start-page"])]),
        _: 1
      });
    };
  }
});